import React from 'react';
import { CanonicalResellerManagementContainer } from 'components';

const CanonicalResellerMerchantManagementComponent = (props) => {
    const { canonicalResellerId } = props.match.params;
    return <CanonicalResellerManagementContainer canonicalResellerId={canonicalResellerId} />;
};

export default CanonicalResellerMerchantManagementComponent;
